<template>
	<nav class="navigation">
		<ul class="links">
			<router-link
				tag="li"
				:class="{'link--active':isActive('plannings')}"
				class="link link--mobile"
				to="/plannings">
				<div class="link__icon">
					<i class="link__icon__element fas fa-clipboard-check"></i>
				</div>
				<p>Home</p>
			</router-link>
			<router-link
				tag="li"
				:class="{'link--active':isActive('week')}"
				class="link link--mobile"
				to="/week">
				<div class="link__icon">
					<i class="link__icon__element fas fa-calendar-week"></i>
				</div>
				<p>Week</p>
			</router-link>
			<router-link
				tag="li"
				:class="{'link--active':isActive('explore')}"
				class="link link--mobile"
				to="/explore">
				<div class="link__icon">
					<i class="link__icon__element fas fa-search"></i>
				</div>
				<p>Explore</p>
			</router-link>
		</ul>
	</nav>
</template>

<script>
import { navigation } from '@/components/mixins/navigation.js'
export default {
	mixins: [navigation]
}
</script>

<style scoped lang="scss">
@import "@/styles/components/_sidebar.scss";
@import "@/styles/components/_navigation.scss";
</style>
